<template>
  <div class="bgf4">
    <!-- <div class="bzxq">标准详情</div> -->
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
        <a-tabs type="card">
          <a-tab-pane key="1" tab="基本信息">
            <!-- <a-card class="card">1111</a-card> -->
            <div>
              <span class="jbxxbzm">{{data.a100}}</span>
              <a-button  :disabled="disabled" class="ztxx" v-if="data.a200=='现行'">
                <span style="font-size:10px;position: relative;right:5px;bottom:1px">{{data.a200}}</span>
              </a-button>
              <a-button  :disabled="disabled" class="ztfz" v-if="data.a200=='废止'">
                <span style="font-size:10px;position: relative;right:5px;bottom:1px">{{data.a200}}</span>
              </a-button>
              <a-button  :disabled="disabled" class="ztwsx" v-if="data.a200=='未生效'">
                <span style="font-size:10px;position: relative;right:8px;bottom:1px">{{data.a200}}</span>
              </a-button>
              <div style="margin-top:20px">
                <span class="jbxxfzwmc">中文名称：<span class="jbxxfzwmc" style="color:red">{{data.a298}}</span></span>
              </div>
              <div style="margin-top:20px">
                <span class="jbxxfzwmc">英文名称：{{data.a302}}</span>
              </div>
              <div style="margin-top:20px">
                <span class="jbxxfzwmc">范围：{{data.a010}}</span>
              </div>
            </div>
            <a-divider :dashed="true" class="jbxxfgx"/>
            <div>
              <div style="margin-top:40px">
                <span class="jbxxbzm">发布日期：{{data.a101}}</span>
              </div>
              <div style="margin-top:20px">
                <span class="jbxxbzm">实施日期：{{data.a205}}</span>
              </div>
              <div style="margin-top:20px">
                <span class="jbxxbzm">废止日期：{{data.a206}}</span>
              </div>
            </div>
            <a-divider :dashed="true" class="jbxxfgx"/>
            <div>
              <div style="margin-top:40px">
                <span class="jbxxbzm">标准组织：{{data.zzh}}</span>
              </div>
              <div style="margin-top:20px">
                <span class="jbxxbzm">全文页数：{{data.a305}}</span>
              </div>
              <div style="margin-top:20px;margin-bottom:40px">
                <span class="jbxxbzm">正文语种：{{data.a1004}}</span>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="关联标准">
            <span class="jbxxbzm">代替标准：{{data.a461}}</span>
            <div style="margin-top:20px">
              <span class="jbxxfzwmc">被代替标准：{{data.a462}}</span></span>
            </div>
            <div style="margin-top:20px">
              <span class="jbxxfzwmc">引用标准：{{data.a1001}}</span></span>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="标准起草单位">
            <template v-for="(item,index) in qcdw" style="display: none;">
              <div :class="[index!='0'?'qcdw':'']">
                <span class="jbxxbzm" >{{ item }}</span>
              </div>
            </template>
          </a-tab-pane>
        </a-tabs>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'

export default {
  name: 'App',
  data(){
    return{
      data:{},
      qcdw:[],
      disabled:true
    }
  },
  computed:{

  },
  created(){
    this.queryByID(this.$route.query.id)
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    queryByID(id){
      http.get('/queryById',{params:{id:id}}
      ).then((res) => {
          this.data = res.data.result
          if(res.data.result.a209){
            let company=(res.data.result.a209).split(';')
            this.qcdw = company
          }
      })
    },
    callback(key) {
    },
  },
}
</script>


<style scoped>
  @import "../../config/AquaticSpecialDetial.css"
</style>







// WEBPACK FOOTER //
// src/views/aquaticspecial/AquaticSpecialDetial.vue